/**
 * Shared i18n resources.
 * Languages stay `en` / `ua` (Redux + choose-language).
 * Nested JSON objects; lookup via dotted keys (`sign_in.forgot_password`)
 * with `keySeparator: '.'` in i18n.config.
 */

import commonEn from './en/common.json';
import validationEn from './en/validation.json';
import errorsEn from './en/errors.json';
import authEn from './en/auth.json';

import commonUa from './ua/common.json';
import validationUa from './ua/validation.json';
import errorsUa from './ua/errors.json';
import authUa from './ua/auth.json';

export const sharedResources = {
  en: {
    common: commonEn,
    validation: validationEn,
    errors: errorsEn,
    auth: authEn,
  },
  ua: {
    common: commonUa,
    validation: validationUa,
    errors: errorsUa,
    auth: authUa,
  },
};

export default sharedResources;
